import { Alert } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { MCPIntegrationType } from "./constants";
import { CommonIntegrationInstance } from "./mcpSlice";
import { RelativeComponentLoader } from "@/components/loader";
import useCustomIntegrations from "./useCustomIntegrations";
import useMCPContext from "./useMCPContext";
import Integration from "./Integration";

const CustomIntegrationsList = () => {
  const { teammate, removeSelectedIntegration, addSelectedIntegration } = useMCPContext();
  const {
    customIntegrations,
    isLoadingCustomIntegrations,
    isCustomIntegrationsError,
    showCustomIntegrationsEmpty,
    showCustomIntegrationsData,
  } = useCustomIntegrations({ shouldRefetchOnWindowFocus: true });

  const onSelect = (instance: CommonIntegrationInstance) => {
    if (teammate?.integrations?.map(i => i.id).includes(instance.id!)) {
      removeSelectedIntegration(instance.id!);
    } else {
      if (instance.type === MCPIntegrationType.MCP) {
        const tools = instance.tools || [];
        addSelectedIntegration({
          ...instance,
          id: instance.id!,
          tools: tools.map(tool => ({ key: tool.key })),
        });
      } else {
        addSelectedIntegration({
          ...instance,
          id: instance.id!,
          tools: [{ key: instance.name }],
        });
      }
    }
  };

  if (isLoadingCustomIntegrations) {
    return <RelativeComponentLoader label="Loading Custom Integrations..." componentHeight={30} />;
  }

  return (
    <div>
      {isLoadingCustomIntegrations && (
        <RelativeComponentLoader label={`Loading Custom Integrations...`} componentHeight={30} />
      )}
      {!isLoadingCustomIntegrations && isCustomIntegrationsError && (
        <Alert className="al-border-0 al-bg-bg-red al-text-gray">
          Error fetching custom integrations
        </Alert>
      )}
      {showCustomIntegrationsEmpty && (
        <Stack
          justify="center"
          direction="column"
          gap="lg"
          align="center"
          className="al-p-8 al-border al-rounded m-4"
        >
          <p className="al-text-2xl">No Custom Integrations</p>
          <p className="al-text-sm al-text-muted-foreground">
            Your custom integrations will show up here after you add one.
          </p>
        </Stack>
      )}
      {showCustomIntegrationsData && (
        <Stack direction="column" className="al-gap-6 al-mb-8">
          <Stack direction="row" wrap className="al-gap-4">
            {customIntegrations?.items.map(instance => (
              <Integration
                key={instance.id}
                integration={instance}
                isSelected={teammate?.integrations?.some(i => i.id === instance.id) ?? false}
                toggleIntegration={() => onSelect(instance)}
                showConfigureButton
              />
            ))}
          </Stack>
        </Stack>
      )}
    </div>
  );
};

export default CustomIntegrationsList;
